"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECOND_HAND_PHRASE_CATALOG = void 0;
const shared = ['yad2'];
const sharedWithRetivut = ['retivut', 'yad2'];
const sharedWithBedek = ['bedek', 'yad2'];
exports.SECOND_HAND_PHRASE_CATALOG = [
    {
        id: 'ys-check-water-pressure',
        title: 'בדיקת לחץ מים תקינה',
        content: 'בוצעה בדיקת לחץ מים, ונמצא כי המערכת פועלת באופן תקין וללא סימני נזילה או ירידת לחץ.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-hot-cold-water-pressure',
        title: 'בדיקת לחץ מים קרים וחמים תקינה',
        content: 'בוצעה בדיקת לחץ לצנרת מים קרים וחמים, ונמצא כי הצנרת תקינה.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-sewage-camera',
        title: 'צילום פנים צנרת ביוב תקין',
        content: 'בוצע צילום פנים צנרת ביוב באמצעות מצלמה סיב־אופטית, והצנרת נמצאה תקינה.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-bath-drain-balloon',
        title: 'קו ביוב אמבטיה–קופסת ביקורת תקין',
        content: 'בוצעה בדיקת תקינות של קו הביוב בין האמבטיה לקופסת הביקורת באמצעות בלון מתנפח, והקו נמצא תקין.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-shower-drain-balloon',
        title: 'קו ביוב מקלחת–קופסת ביקורת תקין',
        content: 'בוצעה בדיקת תקינות של קו הביוב בין המקלחת לקופסת הביקורת באמצעות בלון מתנפח, והקו נמצא תקין.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-inspection-box-balloon',
        title: 'קופסת ביקורת תקינה',
        content: 'בוצעה בדיקת תקינות של קופסת הביקורת באמצעות בלון מתנפח, וקופסת הביקורת נמצאה תקינה.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-moisture-dry',
        title: 'בדיקת רטיבות ללא ממצא חריג',
        content: 'ביום הבדיקה בוצעה בדיקת רטיבות באמצעות מצלמה תרמית ומד לחות, ולא נמצאה לחות באזור הנבדק.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-check-drainage-system',
        title: 'מערכת דלוחין תקינה',
        content: 'בוצעה בדיקת מערכת הדלוחין, והמערכת נמצאה תקינה במועד הבדיקה.',
        blockType: 'bdika',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-defect-moisture-signs',
        title: 'סימני רטיבות והתקלפות',
        content: 'אותרו סימני רטיבות המלווים בהתנפחות ובהתקלפות של שכבת הטיח והצבע.',
        blockType: 'defect',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-defect-pipe-connection-leak',
        title: 'נזילה מחיבורי צנרת מים',
        content: 'קיימת נזילה מחיבורים בצנרת המים, וניכרים סימני קורוזיה והצטברות חלודה סביב החיבורים.',
        blockType: 'defect',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-defect-rusted-main-valve',
        title: 'ברז ראשי חלוד ופגום',
        content: 'הברז הראשי חלוד ופגום, וקיים חשש לתקלה תפקודית בעת השימוש.',
        blockType: 'defect',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-defect-missing-odor-trap',
        title: 'לא אותר מחסום ריח',
        content: 'לא אותר מחסום ריח בנקודת הניקוז, מצב העלול לגרום לחדירת ריחות ממערכת הביוב.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-loose-inspection-cover',
        title: 'מכסה קופסת ביקורת אינו מקובע',
        content: 'מכסה קופסת הביקורת ברצפה אינו מקובע כראוי.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-door-rubs-floor',
        title: 'כנף דלת מתחככת ברצפה',
        content: 'כנף הדלת מתחככת, משתפשפת או נתקעת ברצפה ואינה נעה באופן חופשי.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-mamad-door-hard',
        title: 'דלת ממ״ד נסגרת בקושי',
        content: 'דלת ההדף של הממ״ד נסגרת בטריקה בלבד והידית ננעלת בקושי, באופן העלול להקשות על התפעול בשעת חירום.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-window-lock',
        title: 'חלון או ויטרינה אינם ננעלים',
        content: 'כנף החלון או הוויטרינה אינה ננעלת בצורה תקינה.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-damaged-rubber-seal',
        title: 'גומי אטימה פגום',
        content: 'פס גומי האטימה במשקוף או בכנף הדלת או החלון פגום ואינו יוצר אטימה מלאה.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-reversed-balcony-slope',
        title: 'שיפוע מרפסת הפוך',
        content: 'שיפוע רצפת המרפסת מכוון כלפי פנים הבית במקום כלפי חוץ, מצב העלול לגרום לחדירת מים.',
        blockType: 'defect',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-defect-exterior-wall-cracks',
        title: 'סדקים בקיר חיצוני',
        content: 'אותרו סדקים בקיר החיצוני, העלולים לפגוע באיטום ולאפשר חדירת מים למבנה.',
        blockType: 'defect',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-defect-wall-cracks',
        title: 'סדקים בקיר',
        content: 'אותרו סדקים בקיר. יש להתאים את אופן הטיפול לרוחב הסדק ולעקוב אחר הישנותו.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-jacuzzi-crack',
        title: 'סדק מהותי באמבטיית ג׳קוזי',
        content: 'אותר סדק מהותי באמבטיית הג׳קוזי, העלול לגרום לדליפת מים ולפגיעה באטימות ובשימוש התקין.',
        blockType: 'defect',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-defect-loose-railing-glass',
        title: 'זכוכית מעקה רופפת',
        content: 'זכוכית המעקה מותקנת בצורה רופפת וניתנת להזזה בתוך המסילה, מצב המהווה סכנה בטיחותית.',
        blockType: 'defect',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-defect-loose-sockets',
        title: 'שקעים או מפסקים אינם מחוזקים',
        content: 'שקעים או מפסקים חשמליים אינם מחוזקים היטב לקיר ועלולים להתרופף או להתנתק בשימוש.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-uneven-plaster-paint',
        title: 'גמר טיח וצבע אינו אחיד',
        content: 'גמר הטיח והצבע אינו אחיד, וניכרים סימני מברשת או רולר, גבשושיות או הבדלי גוון.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-wall-not-planar',
        title: 'קיר אינו במישור אחיד',
        content: 'הקיר אינו במישור אחיד, באופן הפוגע באסתטיקה ובאיכות הגמר.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-open-gaps',
        title: 'מרווחים פתוחים בגמר',
        content: 'אותרו מרווחים פתוחים הפוגעים בגמר ומהווים ליקוי אסתטי.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-separation-joints',
        title: 'מילוי מישקי הפרדה לקוי',
        content: 'מילוי מישקי ההפרדה בין אריחי הריצוף לקירות או לחיפוי בוצע בחומר שאינו גמיש או בגמר לקוי.',
        blockType: 'defect',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-defect-missing-heater-shutoffs',
        title: 'חסרים ברזי ניתוק למחמם מים',
        content: 'לא הותקנו ברזי ניתוק בכניסת המים למחמם המים, ולכן לא ניתן לבצע בדיקת תקינות מלאה למערכת ללא ניתוק המחמם.',
        blockType: 'defect',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-defect-low-residual-moisture',
        title: 'רטיבות ברמה נמוכה לאחר תיקון',
        content: 'בהתאם לממצאי מד הלחות והמצלמה התרמית נמצאה רטיבות ברמה נמוכה באזור שבו דווח על אירוע רטיבות קודם.',
        blockType: 'defect',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-defect-shower-seal',
        title: 'איטום חיבורי חדר רחצה לקוי',
        content: 'האיטום בחיבורי קיר–קיר או קיר–רצפה בחדר הרחצה אינו רציף או התיישן.',
        blockType: 'defect',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-required-qualified-professional',
        title: 'תיקון בידי בעל מקצוע מוסמך',
        content: 'נדרש לבצע את התיקון באמצעות בעל מקצוע מוסמך ובהתאם להוראות היצרן ולכללי המקצוע.',
        blockType: 'recommendation',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-required-moisture-follow-up',
        title: 'מעקב לאחר תקופת הגשמים',
        content: 'נדרש לעקוב אחר המקום לאחר תקופת הגשמים. אם יופיעו סימני רטיבות או עלייה בערכי הלחות, יש לבצע בדיקה חוזרת לאיתור המקור.',
        blockType: 'recommendation',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-required-renew-flexible-seal',
        title: 'חידוש איטום גמיש',
        content: 'נדרש להסיר איטום ישן או לקוי, לנקות היטב ולבצע איטום גמיש, תקין ורציף בגמר נקי ואחיד.',
        blockType: 'recommendation',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-required-adjust-door-window',
        title: 'כיוון מנגנון פתיחה ונעילה',
        content: 'נדרש לכוון ולחזק את מנגנון הפתיחה והנעילה עד לקבלת תפעול חלק ותקין, ולהחליף רכיבים פגומים לפי הצורך.',
        blockType: 'recommendation',
        applicableReportTypes: sharedWithBedek,
    },
    {
        id: 'ys-required-replace-damaged-connector',
        title: 'החלפת חיבור צנרת פגום',
        content: 'נדרש להחליף את המחבר הפגום ולוודא אטימות מלאה לאחר התיקון.',
        blockType: 'recommendation',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-comment-existing-conditions',
        title: 'הבדיקה בוצעה בתנאים הקיימים',
        content: 'הבדיקה בוצעה בתנאים הקיימים בנכס ובאמצעים לא הורסים. ממצאים נסתרים אינם ניתנים לאיתור מלא בבדיקה חזותית.',
        blockType: 'comment',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-comment-result-valid-for-date',
        title: 'הממצא נכון למועד הבדיקה',
        content: 'תוצאות הבדיקה והמסקנות נכונות למועד הבדיקה בלבד ובהתאם לתנאים ששררו בנכס באותו מועד.',
        blockType: 'comment',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-comment-monitor-rain',
        title: 'מעקב בזמן גשמים',
        content: 'מומלץ לעקוב אחר האזור בזמן הגשמים ולתעד כל הופעה חוזרת של סימני רטיבות.',
        blockType: 'comment',
        applicableReportTypes: sharedWithRetivut,
    },
    {
        id: 'ys-comment-owner-history',
        title: 'היסטוריית תיקון לפי בעל הנכס',
        content: 'לפי דברי בעל הנכס בוצע בעבר תיקון באזור. המידע לא אומת במסמכי ביצוע ויש להביאו בחשבון בעת המעקב.',
        blockType: 'comment',
        applicableReportTypes: shared,
    },
    {
        id: 'ys-comment-no-water-meter-leak',
        title: 'אין אינדיקציה לנזילה בשעון המים',
        content: 'בהתאם לקריאת שעון המים לא נמצאה אינדיקציה לנזילה בזמן הבדיקה.',
        blockType: 'comment',
        applicableReportTypes: sharedWithRetivut,
    },
];
